import { render, staticRenderFns } from "./ManageExamSchedule.vue?vue&type=template&id=0d5f1641&scoped=true"
import script from "./ManageExamSchedule.vue?vue&type=script&lang=js"
export * from "./ManageExamSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f1641",
  null
  
)

export default component.exports